import "./index.scss";

export function StatusMiniCardList({ client }) {
  return (
    <div className={`card-box-status`}>
      <span className={`px-1 rounded-lg text-1.4rem ${!client?.isDeleted ? "bg-green-50 text-green-700" : "bg-gray-200 text-gray-700"}`}>
        {client?.isDeleted ? "Inativo" : "Ativo"}
      </span>
      <h2 className="pt-4 pb-2 text-blueDark font-bold text-1.4rem limit-10-char">{client?.name}</h2>
    </div>
  );
}
